import { render, staticRenderFns } from "./CustomerDisplayTable.vue?vue&type=template&id=6d98efe2&scoped=true&"
import script from "./CustomerDisplayTable.vue?vue&type=script&lang=ts&"
export * from "./CustomerDisplayTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d98efe2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
